import {
    SPARE_PARTS_ORDERS_CREATE_ATTACHMENTS,
    SPARE_PARTS_ORDERS_DOWNLOAD_PRESIGNED_URL
} from '../../constants/websocketCommands';
import {extractErrorText} from '../actionUtils';
import {uploadSparePartsOrdersAttachment} from '../../api/orders/restSparePartsOrdersAttachments';
import {errorAlert} from '../alertsActions';
import alertMessages from '../../intl/common/alertMessages';

export const SPARE_PARTS_ORDERS_ATTACHMENTS_UPLOADING = 'SPARE_PARTS_ORDERS_ATTACHMENTS_UPLOADING';
export const SPARE_PARTS_ORDERS_ATTACHMENTS_UPLOADING_ERROR = 'SPARE_PARTS_ORDERS_ATTACHMENTS_UPLOADING_ERROR';

export const startUploadAttachments = () => dispatch => {
    return dispatch({type: SPARE_PARTS_ORDERS_ATTACHMENTS_UPLOADING});
};

export const downloadAttachment = (uuid, ticketId, name) => dispatch => {
    return dispatch({
        type: SPARE_PARTS_ORDERS_DOWNLOAD_PRESIGNED_URL,
        sparePartsWebsocket: true,
        command: SPARE_PARTS_ORDERS_DOWNLOAD_PRESIGNED_URL,
        payload: {
            attachment: {
                uuid,
                ticketId,
                name
            }
        }
    });
};

export const uploadAttachments = (attachments = [], correlationId, solutionGroup, carRequestUuid) => dispatch => {
    const promises = [];
    const savedAttachments = [];
    attachments.forEach(attachment => {
        promises.push(
            uploadSparePartsOrdersAttachment(attachment.url, attachment.localUrl, attachment.name, attachment.contentType).then(
                () => {
                    window.URL.revokeObjectURL(attachment.localUrl);
                    savedAttachments.push(attachment);
                }, error => {
                    dispatch({type: SPARE_PARTS_ORDERS_ATTACHMENTS_UPLOADING_ERROR});
                    dispatch(errorAlert(...extractErrorText(error, alertMessages.FILE_UPLOAD_ERROR)));
                }
            )
        )
    });
    return Promise.all(promises).then(() => {
            if (savedAttachments.length > 0) {
                const payload = {
                    attachments: savedAttachments,
                    correlationId,
                    uuid: savedAttachments[0].ticketId,
                    solutionGroup
                };
                if (carRequestUuid) {
                    payload.carRequestUuid = carRequestUuid;
                }
                dispatch({
                    type: SPARE_PARTS_ORDERS_CREATE_ATTACHMENTS,
                    sparePartsWebsocket: true,
                    command: SPARE_PARTS_ORDERS_CREATE_ATTACHMENTS,
                    payload
                })
            } else {
                dispatch({
                    type: SPARE_PARTS_ORDERS_ATTACHMENTS_UPLOADING_ERROR,
                })
            }
        }
    )
};
